import React from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// The history of the money: what was authorised, every rise since, and every prize the pot took on,
// newest first. Each line carries the two totals as they stood right after it happened, so the
// question "when did it become sixteen thousand, and who did that" is answered by reading one row.

const money = (value) =>
     new Intl.NumberFormat("en-GB", {
          style: "currency",
          currency: "GBP",
          maximumFractionDigits: 0,
     }).format(value || 0);

export default function LcvBudgetActivityGrid(props) {
     const { entries } = props;

     return (
          <Box sx={{ mt: 4 }}>
               <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
                    Budget history
               </Typography>

               {entries.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">
                         Nothing has moved the budget yet.
                    </Typography>
               ) : (
                    <Grid data={entries} className="sba-area-data-grid">
                         <GridColumn
                              field="happenedOn"
                              title="When"
                              width="180px"
                              cells={{
                                   data: (cellProps) => (
                                        <td>
                                             {cellProps.dataItem.happenedOn
                                                  ? new Date(cellProps.dataItem.happenedOn).toLocaleString()
                                                  : ""}
                                        </td>
                                   ),
                              }}
                         />
                         <GridColumn field="activityType" title="Type" width="110px" />
                         <GridColumn field="description" title="What happened" width="380px" />
                         <GridColumn
                              field="authorisedTotalGbp"
                              title="Budget after"
                              width="150px"
                              cells={{
                                   data: (cellProps) => <td>{money(cellProps.dataItem.authorisedTotalGbp)}</td>,
                              }}
                         />
                         <GridColumn
                              field="committedTotalGbp"
                              title="Pot after"
                              width="140px"
                              cells={{
                                   data: (cellProps) => <td>{money(cellProps.dataItem.committedTotalGbp)}</td>,
                              }}
                         />
                         <GridColumn field="byWhom" title="By" width="220px" />
                    </Grid>
               )}
          </Box>
     );
}
